
import React, { useState,useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { createWeekPlanDatabase ,editWeekPlanDatabase} from '../../actions/index'


import DayPlanModalCreate from './DayPlanModalCreate';


import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import {
    Row,
    Col,
  } from "reactstrap";

import 'rc-slider/assets/index.css';



const CreateProgramModal = (props) => {
  const {
    buttonLabel,
    className
  } = props;




  const state = useSelector(state => state.auth)
  const dispatch = useDispatch()
  

  Date.prototype.getWeek = function() {
    var date = new Date(this.getTime());
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
    var week1 = new Date(date.getFullYear(), 0, 4);
    const weekNumber = 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7)
    if (weekNumber<10){
      return `${date.getFullYear()}-W0${weekNumber}`
    }
    else{
      return `${date.getFullYear()}-W${weekNumber}`
    }
    
  }

  //console.log(state)
  const [modal, setModal] = useState(false);
  const [form,setForm] = useState(10)
  const [runsPerWeek,setRunsPerWeek] = useState("3")
  const [choosePlaner,setChoosePlaner] = useState("Basic plan 1 Month 1")
  const [dataPlaner,setDataPlaner] = useState("Aerobic,Aerobic,Aerobic,LongRun-Aerobic")

  const [date,setDate] = useState()

  const [duration,setduration] = useState([20,20,20,20,20,20,20])

  const [hrPer,sethrPerc] = useState([70,70,70,70,70,70,70])
  //const [dataChart,setdataChart] = useState([0,0,00,00,00,00,00])

  const [hrPerLow,sethrPerLow] = useState([70,70,70,70,70,70,70])

  const [pickerType,setPickerType] = useState(["Run","Run","Run","Run","Run","Run","Run"])

  const [subType,setsubType] = useState(["Steady","Steady","Steady","Steady","Steady","Steady","Steady"])
  console.log(props)
  const weekDays = ['monday','tuesday','wednesday','thursday','friday','saturday','sunday']
  useEffect(() => {
    if(props.mode === "Edit"){
      const dur = [props.week.monday.dur,props.week.tuesday.dur,props.week.wednesday.dur,props.week.thursday.dur,props.week.friday.dur,props.week.saturday.dur,props.week.sunday.dur]
      const hrP = [props.week.monday.hrPerc,props.week.tuesday.hrPerc,props.week.wednesday.hrPerc,props.week.thursday.hrPerc,props.week.friday.hrPerc,props.week.saturday.hrPerc,props.week.sunday.hrPerc]
      
      const hrPL = [props.week.monday.hrPerLow,props.week.tuesday.hrPerLow,props.week.wednesday.hrPerLow,props.week.thursday.hrPerLow,props.week.friday.hrPerLow,props.week.saturday.hrPerLow,props.week.sunday.hrPerLow]
      sethrPerLow(hrPL)
      const pickerT = [props.week.monday.type,props.week.tuesday.type,props.week.wednesday.type,props.week.thursday.type,props.week.friday.type,props.week.saturday.type,props.week.sunday.type]
      setDate(new Date(props.week.date).getWeek())
      setduration(dur)
      sethrPerc(hrP)
      setPickerType(pickerT)


      let subT = [props.week.monday.subType,props.week.tuesday.subType,props.week.wednesday.subType,props.week.thursday.subType,props.week.friday.subType,props.week.saturday.subType,props.week.sunday.subType]
      subT = subT.map(day => day.includes("Interval")? day : "Steady")
      //console.log(subT)
      setsubType(subT)
    }
    
  }, [props.week])
  
  const changeValues = (day,value,whatToChange) =>{
    var i = weekDays.indexOf(day)
    console.log(date)
    
    if (whatToChange === "Duration"){
        setduration(duration.map((item, j) => {
          if (j === i) {
            return value;
          } else {
            return item;
          }
        })
      )
    }
    if (whatToChange === "PickerType"){
      setPickerType(pickerType.map((item,j) =>{
        if (j === i){
          return value
        }
        else{
          return item
        }
      }))
    }
    if (whatToChange === "SubType"){
      setsubType(subType.map((item,j) =>{
        if (j === i){
          return value
        }
        else{
          return item
        }
      }))
    }
    if (whatToChange === "SetHr"){
      
      sethrPerc(hrPer.map((item,j) =>{
        if (j === i){
          return value
        }
        else{
          return item
        }
      }))
    }
    if (whatToChange === "SetLowHr"){
      sethrPerLow(hrPerLow.map((item,j) =>{
        
        if (j === i){
          return value
        }
        else{
          return item
        }
      }))
    }
    
    
  }
  //console.log(hrPer)
  //console.log(hrPerLow)
  //console.log(subType)
  //console.log(pickerType)
  const toggle = () => setModal(!modal);
  
  const createAddData = (subType,hrPerLow,hrPer,duration) =>{
    //console.log(subType,duration)
    if(subType.includes("1-2")){
      //console.log(subType)
      var addData = []
      var i = 0
      while (duration>0){
        if (i%2==0){
          addData.push(1)
          duration = duration -1
          i = i+1
        }
        else{
          addData.push(2)
          duration = duration -2
          i = i+1
        }

      }
    }
    if(subType.includes("1-3")){
      //console.log(subType)
      var addData = []
      var i = 0
      while (duration>0){
        if (i%2==0){
          addData.push(1)
          duration = duration -1
          i = i+1
        }
        else{
          addData.push(3)
          duration = duration -3
          i = i+1
        }

      }
    }
    if(subType.includes("2-1")){
      //console.log(subType)
      var addData = []
      var i = 0
      while (duration>0){
        if (i%2==0){
          addData.push(2)
          duration = duration -2
          i = i+1
        }
        else{
          addData.push(1)
          duration = duration -1
          i = i+1
        }

      }
    }
    if(subType.includes("3-1")){
      //console.log(subType)
      var addData = []
      var i = 0
      while (duration>0){
        
        if (i%2==0){
          addData.push(3)
          duration = duration -3
          i = i+1
        }
        else{
          addData.push(1)
          duration = duration -1
          i = i+1
        }

      }
    }
    if(subType.includes("1-1")){
      //console.log(subType)
      var addData = []
      var i = 0
      while (duration>0){
        
        if (i%2==0){
          addData.push(1)
          duration = duration -1
          i = i+1
        }
        else{
          addData.push(1)
          duration = duration -1
          i = i+1
        }

      }
    }
    return addData
  }
  const reserve = (heartRate) =>{
    var res = (heartRate - props.user.rest_hr)/(props.user.max_hr-props.user.rest_hr)
    res = parseInt(res*100)
    return res
  }
  const runType = (percent) =>{
    if (percent>80){
        return "Threshold"
    }
    if (percent>70){
    return "Aerobic 2"
    }
    if (percent>60){
    return "Aerobic 1"
    }
    if (percent>50){
    return "Base/Long Run"
    }
    else{
        return " "
    }
}
  const createWeekPlan = () => {
    
    var plan = []
    for (var i=0;i<duration.length;i++){
      if (subType[i] === "Steady"){
        var subTypeAct = runType(reserve(heartRate(hrPer[i])))
        if (pickerType[i] !== "Run"){
          subTypeAct = pickerType[i]
        }
        var day = {type:pickerType[i],dur:duration[i],hrPerc:hrPer[i],subType:subTypeAct,addData:' '}
        plan.push(day)
      }
      else if (subType[i].includes("Interval")){
        const addData = createAddData(subType[i],hrPerLow[i],hrPer[i],duration[i])
        var day = {type:pickerType[i],dur:duration[i],hrPerc:hrPer[i],hrPerLow:hrPerLow[i],subType:subType[i],addData:addData}
        plan.push(day)
      }
      
    }
    dispatch(createWeekPlanDatabase(plan,date))
    console.log(plan,date)
  }
  const editWeekPlan = () => {
    //console.log(duration,pickerType,subType)
    var plan = []
    for (var i=0;i<duration.length;i++){
      if (subType[i] === "Steady"){
        var subTypeAct = runType(reserve(heartRate(hrPer[i])))
        if (pickerType[i] !== "Run"){
          subTypeAct = pickerType[i]
        }
        var day = {type:pickerType[i],dur:duration[i],hrPerc:hrPer[i],subType:subTypeAct,addData:' '}
        plan.push(day)
      }
      else if (subType[i].includes("Interval")){
        const addData = createAddData(subType[i],hrPerLow[i],hrPer[i],duration[i])
        var day = {type:pickerType[i],dur:duration[i],hrPerc:hrPer[i],hrPerLow:hrPerLow[i],subType:subType[i],addData:addData}
        plan.push(day)
      }
      
    }
    dispatch(editWeekPlanDatabase(plan,date,props.id))
    console.log(plan,date)
  }
  

  const heartRate = (hrDay) =>{
    return parseInt(props.user.max_hr*hrDay/100)
  } 
  
 
  
  
  return (
    
    <div>
      {props.mode === 'Create' ? <Button color="warning" onClick={toggle}>New Week</Button> : <Button color="info" onClick={toggle}>Edit</Button>}
      
      <Modal isOpen={modal} toggle={toggle} className={className} style={{backgroundColor:'rgb(40,40,40)'}}>
        <ModalHeader toggle={toggle} style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>Running Program</ModalHeader>
        <ModalBody style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>
          <div class="form-group">

          <input type="week" value={date}onChange={(e)=>setDate(e.target.value)}></input>
          {weekDays.map((day,index) =>{
                        return(
                          <>
                          <DayPlanModalCreate
                            index={index} day={day} 
                            duration={duration[weekDays.indexOf(day)]} 
                            pickerType={pickerType[weekDays.indexOf(day)]}
                            subType = {subType[weekDays.indexOf(day)]} 
                            hrPer = {hrPer[weekDays.indexOf(day)]}
                            hrPerLow = {hrPerLow[weekDays.indexOf(day)]}
                            user = {props.user}
                            
                            //changeSliderValues = {changeSliderValues}
                            changeValues={changeValues} />
                            <Row style={{backgroundColor:'rgb(200,200,200)',marginTop:'20px'}}>          
                                <Col className="pl-4" md="12">
                                    <hr></hr>
                                </Col>
                            </Row>
                            
                            <Row style={{backgroundColor:'rgb(200,200,200)'}}>          
                                <Col className="pl-4" md="12">
                                    <hr></hr>
                                </Col>
                            </Row>
                            </>
                        )
            })}
            

            <Row style ={{backgroundColor:'rgb(50,50,70)'}}>          
                <Col className="pl-4" md="12">
                    <hr></hr>
                </Col>
            </Row>
            <Row style ={{backgroundColor:'rgb(50,50,70)'}}>          
                <Col className="pl-4" md="12">
                    <hr></hr>
                </Col>
            </Row>
      
          </div>

        </ModalBody>
        <ModalFooter style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>
          {props.mode === "Create" ? <Button color="warning" onClick={createWeekPlan}>Generate Week</Button> : <Button color="warning" onClick={editWeekPlan}>Edit Week</Button>}
          
          <Button color="danger" onClick={toggle}>Cancel</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default CreateProgramModal;